/* eslint-disable @typescript-eslint/no-explicit-any */

export default function PortfolioPrintView({
  profile,
  sections,
}: {
  profile: any;
  sections: any[];
}) {
  const processedSections = sections.map((section) => ({
    ...section,
    items: section.items.map((item: any) => ({
      ...item,
      tech:
        typeof item.tags === 'string'
          ? JSON.parse(item.tags || '[]')
          : item.tags || [],
    })),
  }));

  return (
    <div className="hidden print:block bg-white text-black p-8 font-sans">
      {/* Header Section */}
      <div className="flex items-center gap-8 mb-12 border-b-2 border-gray-100 pb-12">
        <div className="relative w-32 h-32 rounded-2xl overflow-hidden border border-gray-200">
          {/* Print-only: skip next/image so the optimizer is not invoked for
              hidden content during normal page loads (caused /_next/image 400s). */}
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img
            src={profile?.image || '/avatar.png'}
            alt={profile?.name || 'Author'}
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
            decoding="async"
          />
        </div>
        <div className="flex-grow">
          <h1 className="text-4xl font-bold mb-2">{profile?.name}</h1>
          <p className="text-xl text-gray-600 mb-4">
            {profile?.availability || 'Software Engineer'}
          </p>
        </div>
      </div>

      {/* Bio Section */}
      <div className="mb-12">
        <h2 className="text-xl font-bold uppercase tracking-wider text-gray-400 mb-4">
          About Me
        </h2>
        <div
          className="text-lg leading-relaxed text-gray-800"
          dangerouslySetInnerHTML={{ __html: profile?.bio || '' }}
        />
      </div>

      {/* Content Sections */}
      <div className="space-y-16">
        {processedSections.map((section) => (
          <div key={section.id}>
            <h2 className="text-xl font-bold uppercase tracking-wider text-gray-400 mb-6">
              {section.title}
            </h2>
            <div className="grid grid-cols-1 gap-10">
              {section.items.map((item: any) => (
                <div
                  key={item.id}
                  className="border-l-4 border-gray-100 pl-6 py-2 break-inside-avoid"
                >
                  <div className="flex justify-between items-start mb-2">
                    <h3 className="text-xl font-bold">{item.title}</h3>
                    {item.link && item.link !== '#' && (
                      <span className="text-[10px] text-gray-400">
                        {item.link.replace('https://', '')}
                      </span>
                    )}
                  </div>
                  {item.subtitle && (
                    <p className="text-sm font-bold text-primary mb-2">
                      {item.subtitle}
                    </p>
                  )}
                  <p className="text-gray-600 mb-4 leading-relaxed text-sm">
                    {item.description}
                  </p>

                  <div className="flex flex-wrap gap-2">
                    {item.tech.map((t: string) => (
                      <span
                        key={t}
                        className="text-[10px] font-bold uppercase tracking-widest bg-gray-100 px-2 py-1 rounded"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* Footer (for print) */}
      <div className="mt-12 pt-8 border-t border-gray-100 text-center text-xs text-gray-400">
        Generated on {new Date().toLocaleDateString()}
      </div>
    </div>
  );
}
